import React, { useRef, useEffect } from 'react';

const CodeInput = ({ code, onChange, disabled }) => {
  const inputRefs = useRef([]);

  useEffect(() => {
    // Focus first input on mount
    if (inputRefs?.current?.[0]) {
      inputRefs?.current?.[0]?.focus();
    }
  }, []);

  const handleChange = (index, value) => {
    // Only allow digits
    if (value && !/^[0-9]$/?.test(value)) return;

    const newCode = [...code];
    newCode[index] = value;
    onChange(newCode);

    // Auto-advance to next input
    if (value && index < 5) {
      inputRefs?.current?.[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    // Handle backspace
    if (e?.key === 'Backspace' && !code?.[index] && index > 0) {
      inputRefs?.current?.[index - 1]?.focus();
    }

    // Handle arrow keys
    if (e?.key === 'ArrowLeft' && index > 0) {
      inputRefs?.current?.[index - 1]?.focus();
    }
    if (e?.key === 'ArrowRight' && index < 5) {
      inputRefs?.current?.[index + 1]?.focus();
    }
  };

  const handlePaste = (e) => {
    e?.preventDefault();
    const pastedData = e?.clipboardData?.getData('text')?.trim();
    
    // Only process if it's 6 digits
    if (/^[0-9]{6}$/?.test(pastedData)) {
      const newCode = pastedData?.split('');
      onChange(newCode);
      inputRefs?.current?.[5]?.focus();
    }
  };

  const handleFocus = (index) => {
    inputRefs?.current?.[index]?.select();
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-medium text-foreground mb-3 text-center">
        Enter Verification Code
      </label>
      <div className="flex justify-center gap-2">
        {code?.map((digit, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={digit}
            onChange={(e) => handleChange(index, e?.target?.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            onFocus={() => handleFocus(index)}
            disabled={disabled}
            className="w-12 h-14 text-center text-2xl font-bold border-2 border-border rounded-lg focus:border-primary focus:outline-none focus:ring-2 focus:ring-primary/20 transition-all disabled:bg-muted disabled:cursor-not-allowed"
          />
        ))}
      </div>
    </div>
  );
};

export default CodeInput;